import { initSlider } from './splidecust';

// const elemSplide = document.querySelector('.elem');
// if (elemSplide) {
//   initSlider(elemSplide, {
//     perPage: 2,
//     gap: '1.5rem',
//     breakpoints: {
//       960: {},
//       768: {},
//     },
//   });
// }

const embSplides = document.querySelectorAll('.emb-splide');
embSplides?.forEach(container => {
  initSlider(container, {
    type: 'fade',
    gap: '1rem',
  });
});

// let elemSliderInstance;
// const elem = document.querySelector('.elem');

// const elemInitSlider = () => {
//   if (elem && !elemSliderInstance) {
//     elemSliderInstance = initSlider(elem, {
//       perPage: 2,
//       gap: '1.5rem',
//       breakpoints: {
//         960: {},
//         768: {},
//       },
//     });
//   }
// };

let chooseSliderInstances = [];
const choose = document.querySelectorAll(
  `
  .choose__splide,
  .follow__splide,
  .alsolike__splide,
  .safety__splide,
  .inhouse__splide,
  .appreciate__splide
  `
);

const chooseInitSliders = () => {
  if (choose && !chooseSliderInstances.length) {
    choose.forEach(container => {
      const slider = initSlider(container, {
        perPage: 2,
        gap: '1rem',
        breakpoints: {
          768: {
            perPage: 1,
          },
        },
      });
      chooseSliderInstances.push(slider);
    });
  }
};

const destroySliders = () => {
  if (chooseSliderInstances) {
    chooseSliderInstances.forEach(instance => {
      instance.destroy();
    });
    chooseSliderInstances = [];
  }
  // if (elemSliderInstance) {
  //   elemSliderInstance.destroy();
  //   elemSliderInstance = null;
  // }
};

const checkViewport = () => {
  chooseInitSliders();
  // elemInitSlider();
  if (window.innerWidth > 960) {
    destroySliders();
  }
};

window.addEventListener('resize', checkViewport);
document.addEventListener('DOMContentLoaded', checkViewport);
